module.exports = __webpack_public_path__ + "img/banner-cadeau.92a9d255.jpg";